import { render, staticRenderFns } from "./DetailsOrder.vue?vue&type=template&id=e9c8c826&scoped=true&lang=html&"
import script from "./DetailsOrder.vue?vue&type=script&lang=js&"
export * from "./DetailsOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9c8c826",
  null
  
)

export default component.exports